// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1LwpH","alert":"SettungsInbox_alert__24paa"};